import React from 'react';
import {
  BellRing,
  Check,
  ClipboardList,
  CreditCard,
  PhoneCall,
  Receipt,
  Stethoscope,
} from 'lucide-react';
import Alt6Layout from '../components/Alt6Layout';
import { CtaBand, Eyebrow, Reveal } from '../components/Alt6Shared';
import { JOURNEY_STEPS } from '../data/site';

const STEP_ICONS = [PhoneCall, ClipboardList, Stethoscope, CreditCard, Receipt, BellRing];

export default function Alt6Journey() {
  return (
    <Alt6Layout title="The patient journey">
      <section className="a6-page-hero">
        <div className="a6-container a6-page-hero-inner">
          <Reveal>
            <Eyebrow>The patient journey</Eyebrow>
          </Reveal>
          <Reveal delay={0.06}>
            <h1>
              Follow one patient, <em>end to end</em>
            </h1>
          </Reveal>
          <Reveal delay={0.12}>
            <p>
              The best way to understand an operating system is to watch it carry a
              single patient from the first ring of the phone to the recall visit six
              months later — with every handoff made, every time.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="a6-section">
        <div className="a6-container">
          <div className="a6-journey">
            {JOURNEY_STEPS.map((step, i) => {
              const Icon = STEP_ICONS[i % STEP_ICONS.length];
              return (
                <Reveal key={step.title} delay={0.05} className="a6-journey-step">
                  <span className="a6-journey-node">
                    <Icon size={17} strokeWidth={2.3} />
                  </span>
                  <div className="a6-journey-card">
                    <div className="a6-journey-phase">{step.phase}</div>
                    <h3>{step.title}</h3>
                    <p>{step.body}</p>
                    <span className="a6-journey-handled">
                      <Check size={13} strokeWidth={3} />
                      {step.handled}
                    </span>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <section className="a6-section-tight a6-wash">
        <div className="a6-container">
          <Reveal className="a6-band">
            <Eyebrow>The point</Eyebrow>
            <h2 className="a6-h2">No step depends on someone remembering.</h2>
            <p className="a6-lede">
              Every one of these handoffs is where practices lose patients and
              revenue today — the callback that never happened, the claim that sat in
              a queue, the recall list nobody had time to work. On Asha, the system
              carries the baton the whole way.
            </p>
          </Reveal>
        </div>
      </section>

      <CtaBand
        title="See the journey with your own workflows."
        body="We'll walk this exact path using a scenario from your practice."
      />
    </Alt6Layout>
  );
}
